import { cacheService } from '../services/cache.service';

export const clearAllCaches = async () => {
  console.log('Clearing all caches...');
  
  // Clear service cache
  cacheService.clear();
  
  // Clear localStorage
  try {
    localStorage.clear();
  } catch (e) {
    console.error('Failed to clear localStorage:', e);
  }
  
  // Clear sessionStorage
  try {
    sessionStorage.clear();
  } catch (e) {
    console.error('Failed to clear sessionStorage:', e);
  }
  
  // Clear IndexedDB if used
  if ('indexedDB' in window) {
    try {
      const databases = await indexedDB.databases();
      databases.forEach(db => {
        if (db.name) {
          indexedDB.deleteDatabase(db.name);
        }
      });
    } catch (e) {
      console.error('Failed to clear IndexedDB:', e);
    }
  }
  
  // Clear Service Worker caches
  if ('caches' in window) {
    try {
      const cacheNames = await caches.keys();
      await Promise.all(
        cacheNames.map(cacheName => caches.delete(cacheName))
      );
    } catch (e) {
      console.error('Failed to clear service worker caches:', e);
    }
  }
  
  console.log('All caches cleared');
};